/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EntityStatus } from './entityStatus';

export interface OperatorDto { 
    _id?: string;
    id?: string;
    name?: string;
    operatorCode?: string;
    countryId?: string;
    mnc?: string;
    mrc?: string;
    cic?: string;
    deleted?: boolean;
    entityStatus?: EntityStatus;
    dateCreated?: Date;
    countryName?: string;
}